import { Box, Grid, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";

export default function ChangeLogModal({ close, data }) {
  const { changeLogData } = data


  return (
    <Box sx={{
      maxWidth: '980px',
      width: '100vw',
      borderRadius: '16px',
      boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
      padding: '14px 16px',
      position: 'relative'
    }}>
        <CloseIcon
          sx={{
            width: '48px',
            height: '48px',
            color: 'primary.black',
            cursor: 'pointer',
            position: 'absolute',
            right: '16px',
            top: '5px'
          }}
          onClick={close}
        />

        <Typography
          variant="h3"
          color='primary.black'
          style={{lineHeight: '28px', textAlign: 'left', width: '100%', marginBottom: '4px'}}
        >
          Change Log
        </Typography>
        <Grid container sx={{ borderBottom: '1px solid #ABB7C0', paddingBottom: '4px', flexWrap: 'nowrap' }}>
          <Grid item xs={2} sx={{minWidth: '60px'}}>
            <Typography variant="h4">Date</Typography>
          </Grid>
          <Grid item xs={2} sx={{minWidth: '80px'}}>
            <Typography variant="h4">Time</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="h4">Change</Typography>
          </Grid>
        </Grid>

        {/* Data Row */}
        <Box style={{
          width: '100%',
          maxHeight: '560px',
          overflowY: 'scroll'
        }} className="notification-dropdown-scroll">
          {changeLogData.map(item => (
            
            <Grid container sx={{paddingTop: '4px', flexWrap: 'nowrap'}}>
              <Grid item xs={2} sx={{minWidth: '60px'}}>
                <Typography variant="body">{ moment(item.node.createdAt).format('YYYY-MM-DD') }</Typography>
              </Grid>
              <Grid item xs={2} sx={{minWidth: '80px'}}>
                <Typography variant="body">{ moment(item.node.createdAt).format('HH:mm:ss') }</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body">{ item.node.change }</Typography>
              </Grid>
            </Grid>
            
          ))}
        </Box>
    </Box>
  )
}